import React, { useContext, useEffect, useState } from 'react'
import Loading from '../../../util/Loading'
import { Link } from 'react-router-dom'
import { deleteRole } from '../../../action';
import ReactPaginate from 'react-paginate'
import { toast, ToastContainer } from 'react-toastify';
import { TabTitle } from '../../../util/titleChanger'
import { GlobalState } from '../../../GlobalState';

export default function RoleDashboard() {
    TabTitle("Role Dashboard");
    const state = useContext(GlobalState)
    const [allRoles] = state.roleAPI.allRoles

    //Local States
    const [rowPerPage] = state.roleAPI.rowPerPage;
    const [setPageNumber] = state.roleAPI.pageNumber;
    const [setSearch] = state.roleAPI.search;
    const [totalPages] = state.roleAPI.totalPages;
    const [callback, setCallback] = state.roleAPI.callback;

    useEffect(() => {
    }, [rowPerPage, allRoles])

    const searchHandle = (event) => {
        event.preventDefault();
        setPageNumber(1)
        setSearch(event.target.value ? event.target.value : "")
    }

    const pageNumberHandler = (data) => {
        let newPageNumber = data.selected + 1
        setPageNumber(newPageNumber);
    }
    const deleteRoleHandler = (id) => {
        deleteRole(id, res => {
            if (res.status === 200) {
                toast.success(res.data);
                setCallback(!callback)
            } else {
                toast.alert(res.data);
                setCallback(!callback)
            }
        })
    }

    return (
        <>
            {
                allRoles.cont === 0 ? <div className="form-container"><div className="loading-page-container"><Loading /></div></div>
                    : < div className='form-container' >
                        <div className="table">
                            <div className="table_header">
                                <p>Role Details</p>
                                <div>
                                    <input type="text" name="search" id="search" onChange={e => searchHandle(e)} placeholder='Search role here...' />
                                    <Link to="/role-form"><button className="add_new">+ Add New</button></Link>
                                </div>
                            </div>

                            <div className="table_section">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {allRoles.roles ? allRoles.roles.map(role => (
                                            <tr key={role.id}>
                                                <td>{role.name}</td>
                                                <td>
                                                    <Link to={`/role-form/${role.id}`}><button><i className="uil uil-edit"></i></button></Link>
                                                    <Link to="#"></Link>
                                                    <button onClick={() => deleteRoleHandler(role.id)}><i className="uil uil-trash-alt"></i></button>
                                                </td>
                                            </tr>
                                        )) : <tr>
                                            <td colSpan="2">Can't found data</td>
                                        </tr>}
                                    </tbody>
                                </table>
                            </div>
                            <ReactPaginate
                                breakLabel="..."
                                nextLabel="next >"
                                onPageChange={pageNumberHandler}
                                marginPagesDisplayed={2}
                                pageCount={totalPages}
                                previousLabel="< previous"
                                renderOnZeroPageCount={null}
                                containerClassName='pagination'
                                pageLinkClassName='page-num'
                                previousLinkClassName='page-num'
                                nextLinkClassName='page-num'
                                activeLinkClassName='active-num'
                            />
                        </div>
                        <ToastContainer />
                    </div >
            }
        </>
    )
}
